import { Popup } from 'components/popup';
import { ListHeader } from 'components/list-header';

import * as Styles from './styles';
import { PopupListProps } from './types';

export const PopupList = ({
  count,
  trigger,
  elements,
  headerTitles,
}: PopupListProps) => (
  <Popup
    trigger={trigger}
    position={[
      'top left',
      'top right',
      'top center',
      'bottom left',
      'bottom right',
      'bottom center',
    ]}
  >
    <Styles.Container>
      <Styles.StyledList
        count={count}
        mainWrapperStyles={{ padding: 8 }}
        header={<ListHeader padding="8px" titles={headerTitles} />}
      >
        {elements}
      </Styles.StyledList>
    </Styles.Container>
  </Popup>
);
